import React from 'react';
import { Modal } from '@aidkitorg/component-library';

// TODO: replace with real form
const EMBEDDED_ASANA_FORM = (
  <div className="asana-embed-container">
    <link rel="stylesheet" href="https://form.asana.com/static/asana-form-embed-style.css"/>
    <iframe className="asana-embed-iframe" height="533" width = "800" src="https://form.asana.com/?k=RmCqd4slczuMAA8obkFr7g&d=1201929137565977&embed=true">
    </iframe>
    <div className="asana-embed-footer">
      <a rel="nofollow noopener" target="_blank" className="asana-embed-footer-link" href="https://asana.com/?utm_source=embedded_form">
        <span className="asana-embed-footer-text">Form powered by</span>
        <div className="asana-embed-footer-logo" role="img" aria-label="Logo of Asana"></div>
      </a>
    </div>
  </div>
)

interface ReportTechnicalIssueModalProps {
  open: boolean;
  onClose: () => void;
}

export const ReportTechnicalIssueModal: React.FC<ReportTechnicalIssueModalProps> = ({ open, onClose }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Report a Technical Issue"
      size="lg"
    >
      {EMBEDDED_ASANA_FORM}
    </Modal>
  );
};
